// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"730":"dde4e32b","4596":"37ba25cf","7752":"309772db","8208":"9bbf67b0","9957":"a0235f60"}[chunkId] + ".chunk.css";
};